import LegalLayout, { Section, List } from "./LegalLayout";

export default function Terms() {
    return (
        <LegalLayout
            title="Terms & Conditions"
            effectiveDate="13 February, 2026"
            intro="Welcome to AV Consultation. By accessing or using our website and services, you agree to the following Terms & Conditions. Please read them carefully."
        >
            <Section number={1} title="About Us" testId="terms-s1">
                <p>
                    AV Consultation is an influencer marketing and brand growth
                    agency operated by Ambuj Vats.
                </p>
                <div className="mt-4 rounded-2xl border border-black/5 bg-[#FAFAFA] p-6">
                    <p className="text-[13px] font-bold tracking-[0.15em] uppercase text-gray-500">
                        Contact Details
                    </p>
                    <p className="mt-3 text-gray-700">
                        Email:{" "}
                        <a
                            href="mailto:ambuj@av-consultation.com"
                            data-testid="terms-contact-email"
                            className="font-semibold text-[#059669] hover:underline"
                        >
                            ambuj@av-consultation.com
                        </a>
                    </p>
                </div>
            </Section>

            <Section number={2} title="Services" testId="terms-s2">
                <p>
                    AV Consultation provides influencer marketing, content
                    strategy, and campaign execution services for brands.
                </p>
                <p>
                    All services are customized based on client requirements.
                    Deliverables, timelines, and pricing are defined in
                    individual agreements or proposals shared with each client.
                </p>
            </Section>

            <Section number={3} title="Engagement & Payments" testId="terms-s3">
                <List
                    items={[
                        "All projects require a confirmed agreement before initiation.",
                        "A deposit or upfront payment is required before work begins.",
                        "Payments once made are non-refundable, unless explicitly agreed in writing.",
                        "Delays in payment may result in pause or termination of services.",
                    ]}
                />
            </Section>

            <Section number={4} title="Performance Disclaimer" testId="terms-s4">
                <p>
                    While we aim to deliver the best possible results, AV
                    Consultation does not guarantee specific outcomes,
                    including but not limited to:
                </p>
                <List
                    items={[
                        "Sales",
                        "Revenue",
                        "Engagement metrics",
                        "Influencer performance",
                    ]}
                />
                <p>
                    Marketing results depend on multiple external factors
                    beyond our control.
                </p>
            </Section>

            <Section number={5} title="Client Responsibilities" testId="terms-s5">
                <p>Clients agree to:</p>
                <List
                    items={[
                        "Provide accurate and complete information",
                        "Approve deliverables within reasonable timeframes",
                        "Maintain clear communication",
                    ]}
                />
                <p>
                    Delays from the client&apos;s side may impact timelines and
                    results.
                </p>
            </Section>

            <Section number={6} title="Intellectual Property" testId="terms-s6">
                <List
                    items={[
                        "All strategies, systems, and frameworks developed by AV Consultation remain our intellectual property unless otherwise agreed.",
                        "Final deliverables (content, campaigns, etc.) may be used by the client as per agreed scope.",
                        "We reserve the right to showcase work as case studies or portfolio, unless a confidentiality agreement is in place.",
                    ]}
                />
            </Section>

            <Section number={7} title="Third-Party Platforms" testId="terms-s7">
                <p>
                    Our services may involve third-party platforms (e.g.,
                    social media platforms, influencer networks).
                </p>
                <p>We are not responsible for:</p>
                <List
                    items={[
                        "Platform policy changes",
                        "Account bans or restrictions",
                        "Algorithm fluctuations",
                    ]}
                />
            </Section>

            <Section number={8} title="Limitation of Liability" testId="terms-s8">
                <p>AV Consultation shall not be held liable for:</p>
                <List
                    items={[
                        "Indirect or consequential losses",
                        "Loss of profits, data, or business opportunities",
                        "Issues arising from third-party services or influencers",
                    ]}
                />
                <p>
                    Our total liability, if any, shall not exceed the amount
                    paid for the specific service.
                </p>
            </Section>

            <Section number={9} title="Termination" testId="terms-s9">
                <p>We reserve the right to terminate or refuse service if:</p>
                <List
                    items={[
                        "Terms are violated",
                        "Misuse or unethical practices are observed",
                        "Communication or cooperation breaks down",
                    ]}
                />
            </Section>

            <Section number={10} title="Confidentiality" testId="terms-s10">
                <p>
                    Both parties agree to keep confidential information
                    private and not disclose it without consent.
                </p>
            </Section>

            <Section number={11} title="Modifications" testId="terms-s11">
                <p>
                    We may update these Terms &amp; Conditions at any time.
                    Continued use of our services implies acceptance of the
                    updated terms.
                </p>
            </Section>

            <Section number={12} title="Governing Law" testId="terms-s12">
                <p>
                    These Terms shall be governed by and interpreted in
                    accordance with the laws of India. Any disputes shall be
                    subject to the jurisdiction of courts in Ranchi, Jharkhand.
                </p>
            </Section>

            <Section number={13} title="Contact" testId="terms-s13">
                <p>For any questions regarding these Terms, you can contact:</p>
                <div className="mt-4 rounded-2xl border border-black/5 bg-[#FAFAFA] p-6">
                    <p className="font-display font-semibold text-[#0A0A0A]">
                        Ambuj Vats
                    </p>
                    <p className="text-gray-600">AV Consultation</p>
                    <p className="mt-2 text-gray-700">
                        Email:{" "}
                        <a
                            href="mailto:ambuj@av-consultation.com"
                            data-testid="terms-contact-email-bottom"
                            className="font-semibold text-[#059669] hover:underline"
                        >
                            ambuj@av-consultation.com
                        </a>
                    </p>
                </div>
                <p className="mt-6 text-gray-600">
                    By using our website or services, you agree to these Terms
                    &amp; Conditions.
                </p>
            </Section>
        </LegalLayout>
    );
}
